import { Link } from "react-router-dom";
import { clsx } from "clsx";
import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  href?: string;
  variant?: "primary" | "secondary" | "ghost";
  children: ReactNode;
};

const variants = {
  primary:
    "bg-gradient-to-r from-cyan-400 via-sky-500 to-blue-600 text-white shadow-[0_18px_48px_rgb(14_165_233_/_0.34),inset_0_1px_0_rgb(255_255_255_/_0.18)] hover:from-cyan-300 hover:via-sky-400 hover:to-blue-500 hover:shadow-[0_22px_55px_rgb(14_165_233_/_0.4),inset_0_1px_0_rgb(255_255_255_/_0.2)]",
  secondary: "border border-cyan-200/25 bg-white/8 text-white shadow-[inset_0_1px_0_rgb(255_255_255_/_0.06)] hover:border-cyan-200/45 hover:bg-white/12",
  ghost: "text-slate-200 hover:bg-white/10"
};

export function Button({ className, href, variant = "primary", children, ...props }: ButtonProps) {
  const classes = clsx(
    "inline-flex min-h-12 items-center justify-center rounded-2xl px-5 py-3 text-sm font-semibold transition duration-200 disabled:pointer-events-none disabled:opacity-60",
    variants[variant],
    className
  );

  if (href) {
    return (
      <Link className={classes} to={href}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
